import http from 'hub-http/clients/apiClient';
const BASE_URL = '/submissions/app/v1/alerts';
export const fetchSubmissionAlert = () => http.get(`${BASE_URL}/submission_reports`);